<template>

  <section>



    <div class="img">
      <div>
        <img src="../assets/ad1.jpg" style="width: 100%;height: 100%;" v-on:click="appointment()" />
      </div>
    </div>

    <div class="demand" style="margin-top: -3215px;" v-if="this.phoneType=='android'">

      <div style="width:100%;display: flex;justify-content: space-evenly;">
        <div style="font-size: 15px;">名字<span style="color: red;font-size: 12px !important;">(必填)</span></div>
        <Input v-model="name" clearable placeholder="请输入您的名字" style="width: 50%;border: 1px solid #e3e3e3;background: #ebebeb;border-radius: 10px;"/>
      </div>

      <div style="width:100%;display: flex;justify-content: space-evenly;margin: 20px 0;">
        <div style="font-size: 15px;">电话<span style="color: red;font-size: 12px !important;">(必填)</span></div>
        <Input v-model="phone" type="tel" clearable placeholder="请输入您的电话" style="width: 50%;border: 1px solid #e3e3e3;background: #ebebeb;border-radius: 10px;"/>
      </div>

      <div style="width:100%;display: flex;justify-content: space-evenly;">
        <div style="font-size: 15px;">人数<span style="color: red;font-size: 12px !important;">(必填)</span></div>
        <Input v-model="demand" clearable  placeholder="请输入人数。"style="width: 50%;border: 1px solid #e3e3e3;background: #ebebeb;border-radius: 10px;" />
      </div>

    </div>
    
    <div class="demand" style="margin-top: -3700px;" v-if="this.phoneType=='iPhone'">
    
      <div style="width:100%;display: flex;justify-content: space-evenly;">
        <div style="font-size: 15px;">名字<span style="color: red;font-size: 12px !important;">(必填)</span></div>
        <Input v-model="name" clearable placeholder="请输入您的名字" style="width: 50%;border: 1px solid #e3e3e3;background: #ebebeb;border-radius: 10px;"/>
      </div>
    
      <div style="width:100%;display: flex;justify-content: space-evenly;margin: 20px 0;">
        <div style="font-size: 15px;">电话<span style="color: red;font-size: 12px !important;">(必填)</span></div>
        <Input v-model="phone" type="tel" clearable placeholder="请输入您的电话"style="width: 50%;border: 1px solid #e3e3e3;background: #ebebeb;border-radius: 10px;"/>
      </div>
    
      <div style="width:100%;display: flex;justify-content: space-evenly;">
        <div style="font-size: 15px;">人数<span style="color: red;font-size: 12px !important;">(必填)</span></div>
        <Input v-model="demand" clearable  placeholder="请输入人数。"style="width: 50%;border: 1px solid #e3e3e3;background: #ebebeb;border-radius: 10px;" />
      </div>
    
    </div>

  </section>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import addressApi from '../request/addressApi';
  import userApi from '../request/userApi';
  import axios from 'axios';
  export default {
    name: 'travelAD1',
    data() {
      return {
        name:'',
        phone:'',
        demand:'',
        phoneType:'',
      };
    },
    components: {},
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      this.getphoneType();
      this.getUserAddress();
    },
    activated() {},
    methods: {
      getphoneType(){
        //获取userAgent信息
        var userAgentStr = navigator.userAgent;
        var iPhone = new RegExp("iPhone");
        var Android = new RegExp("Android");;
        if(iPhone.test(userAgentStr)){
          this.phoneType = "iPhone";
          console.log('phoneType',this.phoneType);
        }
        else if(Android.test(userAgentStr)){
          this.phoneType = "android";
          console.log('phoneType',this.phoneType);
        }
      },
      getUserAddress() {
        // 获取地址列表
        userApi.getUserData(this.$store.state.user.OpenId).then(sucRes =>{
          if (sucRes.success && sucRes.totalCount > 0) {
            this.name = sucRes.data.RealName;
            this.phone = sucRes.data.Mobile;
          }
        })
      },

      appointment() {
        var that = this;

        if (this.name == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的名字不能为空'
          });
          return;
        }
        if (this.phone == '' || this.phone.length < 8 || this.phone.length > 11 || this.phone.length == 9 || this.phone.length == 10) {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的联系电话不能为空或者电话号码长度不正确'
          });
          return;
        }
		if (this.demand == '') {
		  this.$Modal.warning({
		    title: '操作提示',
		    content: '人数不能为空'
		  });
		  return;
		}
        console.log(this.$store.state.user.OpenId, this.name, this.phone);
        flightApi.appointmentFlight(
            this.$store.state.user.OpenId,
            '旅游VIP新品发布会',
            this.name,
            this.phone,
            '旅游VIP新品发布会:' + '人数:' + this.demand + '人',
            null,
            null,
          )
          .then(sucRes => {
            this.demand = '';
            this.name = '';
            this.phone = '';
            if (sucRes.success == true) {
              this.$Modal.success({
                title: '恭喜您!预约成功！',
                content: sucRes.message
              });
            } else {
              this.$Modal.error({
                title: '很遗憾!预约失败！',
                content: sucRes.message
              });
            }
          });

      },
    },
  };
</script>

<style>

  .img{
    width: 100%;
    /* margin: 0 2%; */
  }

</style>



// WEBPACK FOOTER //
// src/components/travelAD1.vue